import { CORE_ARTICLES } from "./articles-core";
import { MONEY_ARTICLES } from "./articles-money";
import { FAQ_ARTICLES } from "./articles-faq";

export const ARTICLES = { ...CORE_ARTICLES, ...MONEY_ARTICLES };
export const FAQS = FAQ_ARTICLES;

export const getArticle = (slug) => ARTICLES[slug] || null;
export const getFaq = (slug) => FAQS[slug] || null;

export const ALL_ARTICLE_SLUGS = Object.keys(ARTICLES);
export const ALL_FAQ_SLUGS = Object.keys(FAQS);
